import React from "react";
import PageHeader from "../views/PageHeader";
import Div from "../views/Div";
import {Avatar, Badge, Result, Tag} from "antd";
import {CrownOutlined, DeploymentUnitOutlined, DollarOutlined, ToolOutlined} from "@ant-design/icons";
import './Subordinates.less';
import Card from "../views/Card";
import BlockHeader from "../views/BlockHeader";

export default class Subordinates extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            leftRouterState: false,
            subUsers: [1, 2, 3, 4, 5, 6],
        };
    }

    renderUserCards = () => {
        let ret = [];

        for (let i = 0; i < this.state.subUsers.length; i++) {
            let score = 35;
            ret.push(<Card className='SubUserCard'>
                <div className='leftPart'>
                    <div className='avatar'>
                        <div style={{height: '40%'}} className='ratingBar'/>
                        <div className='scoreContainer'>
                            <div className='score'>{score}</div>
                        </div>
                        <Avatar shape='square' className='avatar' size='large' style={{backgroundColor: '#1890ff'}}>ВК</Avatar>
                    </div>
                </div>
                <div className='rightPart'>
                    <div className='header'>
                        <div className='name'>Виталий</div>
                        <div className='status'><Tag className='primaryGreen'>Онлайн</Tag></div>
                    </div>
                    <div className='position'>Руководитель</div>
                    <div className='userItems'>
                        <div className='item purpose'>
                            <BlockHeader className='itemName' text='Цель' status='blue'/>:
                            <span className='itemValue'> Тесты</span>
                        </div>
                        <div className='item task'>
                            <BlockHeader className='itemName' text='Планирование цели' status='orange'/>
                            <span className='itemValue'></span>
                        </div>
                    </div>
                    <div className='bottomInfo'>
                        <Tag color='green' icon={<DollarOutlined/>}>250 ₽ / час</Tag>
                        <Tag color='orange' icon={<CrownOutlined/>}>30</Tag>
                        <Tag color='magenta' icon={<DeploymentUnitOutlined/>}>48</Tag>
                    </div>
                </div>
            </Card>);
        }

        return ret;
    }

    render() {
        return (
            <div className='Subordinates'>
                <PageHeader title='Подчиненные'/>
                <Div>
                    <Result
                        icon={<ToolOutlined fill='#1890ff' />}
                        title="В разработке"
                    />
                </Div>
                {/*<Div>*/}
                {/*    <div className='usersCardsList'>*/}
                {/*        {this.renderUserCards()}*/}
                {/*    </div>*/}
                {/*</Div>*/}
            </div>
        );
    }
}